import { lazy, ComponentType } from "react";
import { WizardStepConfig } from "./CancelWizard/wizardHelpers";
import { MailingAddress } from "../../../DataModels/DataModels";
import { CatalogItem } from "../Output/CreditStoreItemCard";

// Type-safe modal names
export type ModalType =
	| "ContactUs"
	| "AddJob"
	| "UpgradeSub"
	| "AddExisting"
	| "CancelWizard"
	| "ShareWizard"
	| "MailingAddress"
	| "CreditStore";

// Modal props interfaces
export interface ContactUsProps {
	onSend?: (data: { name: string; email: string; message: string }) => void;
}

export interface AddJobProps {
	onSave?: (data: {
		company: string;
		role: string;
		description: string;
		generateCoverLetter: boolean;
		generateResume: boolean;
	}) => void;
}

export interface UpgradeSubProps {}

export interface AddExistingProps {
	onSave?: (data: {
		company: string;
		role: string;
		description: string;
		generateCoverLetter: boolean;
		generateResume: boolean;
	}) => void;
}

export interface CancelWizardProps {
	defaultStep: WizardStepConfig;
	steps: WizardStepConfig[];
	data: Record<string, unknown>;
	onCancel: () => Promise<void>;
	onKeep?: () => void;
}

export interface ShareWizardProps {
	mode: "friend" | "group";
	onCreateReferral?: (
		data: any
	) => Promise<{ code: string; shareLink: string; expiresAt: string }>;
}

export interface MailingAddressProps {
	defaultAddress?: MailingAddress | null;
	onConfirm: (address: MailingAddress) => void;
}

export interface CreditStoreProps {
	catalogItems?: CatalogItem[];
	userBalance?: number;
	onRedeem?: (itemKey: string) => void;
}

// Map of modal types to their props
export type ModalPropsMap = {
	ContactUs: ContactUsProps;
	AddJob: AddJobProps;
	UpgradeSub: UpgradeSubProps;
	AddExisting: AddExistingProps;
	CancelWizard: CancelWizardProps;
	ShareWizard: ShareWizardProps;
	MailingAddress: MailingAddressProps;
	CreditStore: CreditStoreProps;
};

// Registry mapping modal types to their components
// Using mapped type to ensure each modal gets its specific props type
export const ModalRegistry: {
	[K in ModalType]: ComponentType<ModalPropsMap[K]>;
} = {
	ContactUs: lazy(() => import("./ContactUs")),
	AddJob: lazy(() => import("./AddJob")),
	UpgradeSub: lazy(() => import("./UpgradeSub")),
	AddExisting: lazy(() => import("./AddExisting")),
	CancelWizard: lazy(() => import("./CancelWizard")),
	ShareWizard: lazy(() => import("./ShareWizard")),
	MailingAddress: lazy(() => import("./MailingAddressModal")),
	CreditStore: lazy(() => import("./CreditStoreModal"))
};
